import React from 'react';

const AccessDeniedPage = (message) => {
    console.log("Access denied")
    return (
        <div className="flex flex-col ml-20 shadow-xl shadow-red-500/30 bg-[#f9f9f9] rounded w-1/4">
            <div className="text-600 text-red-700 font-bold  text-2xl underline ml-3 ">Access Denied</div>
            <div className="mt-2 ml-3">You don't have permission to view this page. </div> 
            <div className="mt-2 ml-3 mb-3"> Please contact esops@crestron.com to get access.</div>

        </div>
        
    );
};

export default AccessDeniedPage;